import { connect } from 'react-redux';

import {
  mapStateToProps,
  mapDispatchToProps,
} from './props';

import AdminSpecificMeetingView from './AdminSpecificMeetingView';

export default connect(mapStateToProps, mapDispatchToProps)(AdminSpecificMeetingView);
